import { useState } from 'react';
import Overlay from 'react-bootstrap/Overlay';
import Popover from 'react-bootstrap/Popover';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Spinner } from '../../../../../components/Spinner';
import { NumericFormat } from 'react-number-format';
import { useEnv } from '../../../../../context/env-context';
import { useAuth } from '../../../../../hooks/useAuth';
import { makeRequest } from '../../../../../utils/makeRequest';
import { toast } from 'react-toastify';

function ConsumerPopoverAlertForm({ target, popoverOpen, handleToggle, consumerId, getAlerts }) {
  const { apiOriginConsumer } = useEnv();
  const { getAccessTokenSilently } = useAuth();

  const [spinner, setSpinner] = useState(false);

  const [alertType, setAlertType] = useState('AVAILABLE_BALANCE');
  const [alertData, setAlertData] = useState({});

  const close = () => {
    setAlertType('');
    setAlertData({});
    handleToggle();
  };

  const createNewAlert = async () => {
    setSpinner(true);
    const token = await getAccessTokenSilently();

    if (!token) {
      return;
    }

    const config = {
      token,
      url: `${apiOriginConsumer}/alerts/add`,
      method: 'POST',
      data: JSON.stringify({ consumerId, type: alertType, data: alertData }),
    };

    try {
      await makeRequest(config);
      await getAlerts();

      close();

      toast.success('New alert has been created');
    } catch (error) {
      toast.error(error.message);
    } finally {
      setSpinner(false);
    }
  };

  return (
    <Overlay
      show={popoverOpen}
      target={target.current}
      placement="right"
      popperConfig={{ modifiers: [{ name: 'offset', options: { offset: [0, 0] } }] }}
    >
      {props => (
        <Popover {...props} className="custom-popover">
          <Popover.Body className="bo-common-popover-form-menu bo-w-220">
            <Spinner visible={spinner} size={36}>
              <Form.Label className="bo-common-popover-form-menu-label">Type:</Form.Label>
              <Form.Select
                className="bo-common-popover-form-menu-input"
                onChange={e => setAlertType(e.target.value)}
              >
                <option value="AVAILABLE_BALANCE">Available Balance</option>
                <option value="CURRENT_BALANCE">Current Balance</option>
                <option value="ALL_BALANCES">All Balances</option>
                <option value="PAYROLLS_CYCLES">Payroll Cycles</option>
                <option value="BANK_ACCOUNT_HISTORY">Bank Account History</option>
              </Form.Select>
              <Form.Label className="bo-common-popover-form-menu-label">Threshold:</Form.Label>
              <NumericFormat
                type="text"
                className="bo-common-popover-form-menu-input"
                value={alertData.threshold}
                onChange={e => setAlertData({ ...alertData, threshold: String(e.target.value) })}
                customInput={Form.Control}
                decimalScale={0}
              />
              <div className="mt-3 d-flex justify-content-between">
                <Button
                  className="bo-common-button"
                  onClick={createNewAlert}
                  disabled={!alertData.threshold}
                >
                  Save
                </Button>
                <Button className="bo-common-button" onClick={close}>
                  Cancel
                </Button>
              </div>
            </Spinner>
          </Popover.Body>
        </Popover>
      )}
    </Overlay>
  );
}

export default ConsumerPopoverAlertForm;
